import { useAppInstanceConfigFeature } from 'hooks/use-app-instance-config-feature.hook';
import { useFloorplanViewState } from 'floorplan/pages/native-floorplan/hooks/use-floorplan-view-state.hook';

/**
 * Whether the resources page shows the mapbox map view — the split screen with a pin map beside the
 * list, and the swipe modal that holds the list on mobile.
 *
 * Off wherever the native floorplan redesign is on. The two are the same idea twice: a map of the
 * building next to its resources. The redesign brings its own map, its own toggle to reach it and a
 * plain list of cards for the other half, so letting the mapbox view claim the page as well would
 * give the user two maps and bury the cards in a sheet.
 *
 * Read this rather than `useAppInstanceConfigFeature().isMapViewEnabled`, which answers only what the
 * app instance config asks for.
 */
export const useIsMapViewEnabled = (): boolean => {
  const { isMapViewEnabled } = useAppInstanceConfigFeature();
  const { isFloorplanAvailable } = useFloorplanViewState();

  return isMapViewEnabled && !isFloorplanAvailable;
};
